import "./style.scss";

import { Button } from "@mui/material";
import StyledButton from "components/shared/StyledButton";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { fetchSendBeneficiarStatement, fetchSendStatement } from "store/managementStore";
import { useAppDispatch, useAppSelector } from "store/store";

type TProps = {
    close: () => void;
    selectedRows: number[];
    tabValue: number;
};

const StatementModal = ({ close, tabValue, selectedRows }: TProps) => {
    const { activePeriod } = useAppSelector((state) => state.period);
    const [t] = useTranslation();
    const dispatch = useAppDispatch();
    const handleGetBulkStatement = useCallback(() => {
        if (activePeriod) {
            if (tabValue === 0) {
                dispatch(
                    fetchSendStatement({
                        periodId: activePeriod,
                        terms: selectedRows,
                        host: window.location.origin,
                    }),
                );
            } else if (tabValue == 1) {
                dispatch(
                    fetchSendBeneficiarStatement({
                        periodId: activePeriod,
                        beneficiars: selectedRows,
                        host: window.location.origin,
                    }),
                );
            }
            close();
        }
    }, [activePeriod, dispatch, selectedRows, tabValue]);

    return (
        <>
            <div className="statement-download-wrapper">
                <div className="dowload-info">
                    <p>
                        {t("Management.YouSelect")}{" "}
                        <b>
                            {selectedRows.length} {t("Management.Elements")}
                        </b>
                        . {t("Management.WantDownload")}
                    </p>
                    <p>{t("Management.ReceiveLink")}</p>
                </div>
                <div className="download-controls">
                    <StyledButton buttonType="secondary" onClick={close} fullWidth>
                        {t("Management.NoCancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" onClick={handleGetBulkStatement} fullWidth>
                        {t("Management.YesDownload")}
                    </StyledButton>
                </div>
            </div>
        </>
    );
};

export default StatementModal;
